import LocaleHelper from './locale-helper';
import { CONFIG } from '../../../common/config';
export var addLocalePrefixToRoutePath = function (path) {
    return "/:locale(" + CONFIG.LOCALES.ALLOWED.join('|') + ")" + path;
};
export var isValidRedirectUrl = function (url) {
    var locales = CONFIG.LOCALES.ALLOWED.join('|');
    return !!url.match(new RegExp("^/(" + locales + ")(/.*)?(\\?.*)?$"));
};
export var localizeUrl = function (uri) {
    if (uri === void 0) { uri = ''; }
    var locale = LocaleHelper.getCurrentLocale();
    var parts = uri.split('/')
        .filter(function (value) { return '' !== value; });
    if (parts.shift() === locale) {
        return uri;
    }
    return "/" + locale + ('/' !== uri[0] ? '/' : '') + uri;
};
